<h1 mat-dialog-title>Map Competency</h1>
<div mat-dialog-content>
    <mat-label class="h5 label-bold">Employee Name:</mat-label>
    <div class="form-control1 field_value1">
        <app-typeahead-textbox [allValues]="employeeSelected" [values]="employeeIds"
            (emittedValues)="applyFilter($event)" [placehold]="placeholderEmployees">
        </app-typeahead-textbox>
    </div><br>
    <div>
        <mat-label class="h5 label-bold">Competency:</mat-label>
        <mat-select #filetype class="form-control file-type fs-14 black-clr" placeholder="Select Competency"
            [(value)]="competencySelected" (selectionChange)="onCompetencyChange($event)"
            [disabled]="isEmployeeSelected">
            <mat-option *ngFor="let line of serviceLines" [value]="line">{{line.name}}</mat-option>
        </mat-select>
    </div><br />
    <div>
        <mat-label class="h5 label-bold">SubCompetency:</mat-label>
        <mat-select #filetype class="form-control file-type fs-14 black-clr" placeholder="Select Sub-Competency"
            [formControl]="subCompetencyControl">
            <mat-option *ngFor="let line of subServiceValues" [value]="line.name"
                [hidden]="line.isDefault">{{line.name}}</mat-option>
        </mat-select>
    </div>
</div>
<div mat-dialog-actions class="closebtn justify-content-end">
    <button mat-dialog-close class="btn ml-2 mr-2 custom_btn inverted_btn_base" (click)="close()">Cancel</button>
    <button (click)="closeDialog()" [disabled]="subCompetencyControl.value.length===0 || isEmployeeSelected"
        class="btn custom_btn primary_btn_base d-flex align-items-center ml-2">Save</button>
</div>